export default __webpack_public_path__ + "static/media/logo.6bf8a23c.svg";